<template>
  <div ref="uploadList" style="height: 400px;">
    <div class="mr-b-30">
      <p><b>テンプレートファイルには登録可能なすべてのASINのリストが入力されています</b></p>
      <button class="btn btn-primary" @click="handleDowloadTemplate">
        テンプレートをダウンロード
        <i class="fa fa-download" aria-hidden="true"></i>
      </button>
    </div>
    <p><b>応募する商品のASINリストファイルをアップロードしてください</b></p>
    <vue-dropzone
      ref="myVueDropzone"
      id="dropzone"
      :options="this.option"
      @vdropzone-success="handleSuccess"
      @vdropzone-file-added="handleFileAdded"
      @vdropzone-removed-file="handleRemovedFile"
    >
    </vue-dropzone>
    <div class="text-right m-t">
      <button class="btn btn-primary" :disabled="isDisabledUpload" @click="updateFiles">追加する</button>
    </div>
    <entry-error
      v-if="failedCount > 0"
      :total="total"
      :failedCount="failedCount"
      :eventCode="eventCodeDownload"
    />
  </div>
</template>

<script>
import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import EntryError from './SaleEntryError'
import SaleService from '@/services/salemasterservice'
import moment from 'moment'
import * as code from '@/common/code'
import EventService from '@/services/eventservice'
import eventCode from '@/common/event-code'

export default {
  components: {
    vueDropzone: vue2Dropzone,
    EntryError
  },
  computed: {
    saleId () {
      return this.$route.params.saleId
    },
    option () {
      return {
        url: `${process.env.NODE_SERVER_API}sale/entry/upload`,
        headers: { 'Authorization': `Bearer ${localStorage.getItem('tokenSalmon')}` },
        params: {
          saleId: this.saleId
        },
        thumbnailWidth: 150,
        maxFilesize: 150,
        maxFiles: 1,
        acceptedFiles: 'text/csv,text/plain',
        addRemoveLinks: true,
        autoProcessQueue: false,
        dictDefaultMessage: 'ファイルをここにドラッグ&ドロップ<br><br><button class="btn btn-info w-200">またはファイルを選択</button>',
        dictInvalidFileType: 'この形式のファイルはアップロードできません。',
        dictMaxFilesExceeded: '複数のファイルをアップロードすることはできません。'
      }
    },
    eventCodeDownload () {
      return eventCode.sale.entry.upload.download_report
    }
  },
  data () {
    return {
      loader: null,
      isDisabledUpload: true,
      total: 0,
      failedCount: 0
    }
  },
  methods: {
    loading () {
      this.loader = this.$loading.show({
        container: this.$refs.uploadList,
        backgroundColor: 'rgba(255,255,255,0.7)',
        canCancel: false,
        width: 40,
        height: 40,
        zIndex: 1000
      })
    },
    handleFileAdded (file) {
      const dz = this.$refs.myVueDropzone.dropzone
      if (dz.files.length > 1) {
        dz.removeFile(dz.files[0])
      }
      this.isDisabledUpload = false
    },
    handleRemovedFile () {
      this.isDisabledUpload = true
    },
    handleSuccess (file, response) {
      this.loader && this.loader.hide()
      if (response.header.resultCode !== code.success) {
        this.$refs.myVueDropzone.removeAllFiles()
        this.$events.fire('handleError', response.header.message)

        return
      }

      if (response.records.data.passAsins.length > 0) {
        this.$emit('setAddedAsins', response.records.data.passAsins)
      }
      this.total = response.records.data.total
      this.failedCount = response.records.data.failedCount
      this.$refs.myVueDropzone.removeAllFiles()
    },
    updateFiles () {
      if (this.isDisabledUpload) {
        return false
      }

      if (this.$refs.myVueDropzone.getQueuedFiles().length) {
        const logParams = {
          name: eventCode.sale.entry.upload.add,
          properties: {
            saleId: this.saleId
          }
        }
        EventService.postTrackLog(logParams)

        this.loading()
        this.$refs.myVueDropzone.processQueue()
      } else {
        this.$refs.myVueDropzone.removeAllFiles()
      }
    },
    async handleDowloadTemplate () {
      const logParams = {
        name: eventCode.sale.entry.upload.download_template,
        properties: {
          saleId: this.saleId
        }
      }
      EventService.postTrackLog(logParams)

      let filename = this.getFileName()
      await SaleService.downloadTemplate({}, filename)
        .catch(error => {
          this.$events.fire('handleError', error)
        })
    },
    getFileName () {
      let sellerid = this.$store.getters.getUser.sellerId
      let reportTime = moment(new Date()).format('YYYYMMDDHHmmss')
      let filename = `asinList_${sellerid}_${reportTime}.csv`
      return filename
    }
  },
  mounted () {
    this.$refs.myVueDropzone.removeAllFiles()
  },
  beforeDestroy () {
    this.$emit('close')
    this.$refs.myVueDropzone.removeAllFiles()
    $('.modal-backdrop').remove()
  }
}
</script>
<style scoped>
.dropzone {
  max-height: 250px;
  padding: 10px;
}
</style>



// WEBPACK FOOTER //
// src/view/sale/components/SaleEntryUploadList.vue